import { useSelector } from "react-redux";
import { IMediaSearchStateModel } from "../models";
import { IAppState } from "../store";

export const useMediaSearchSelector = () => {
  return useSelector<IAppState, IMediaSearchStateModel>(
    (store) => store.media.mediaSearch
  );
};
